import type { ProStudioContext } from '../xstate/prostudio.xstate.types';

/**
 * The solution the route has open: its id once the list has it, else the
 * route's name. Compared before and after the publish answers, so an answer
 * that lands after the person moved on can tell. (project-bobcat keys this on
 * main's `selectOpenSolutionId`, which candidate doesn't have.) Lives here,
 * free of the store and the machines, so the version loader can key on it
 * too without an import cycle.
 */
export const openSolutionKey = (
  ctx: Pick<ProStudioContext, 'botName' | 'solutions'>
): string | null => findOpenSolution(ctx)?.id ?? ctx.botName ?? null;

/** The open solution's entry in the list, by the route's name; see above. */
export const findOpenSolution = (
  ctx: Pick<ProStudioContext, 'botName' | 'solutions'>
) =>
  ctx.solutions?.find(
    (s) => s.name === ctx.botName || s.displayName === ctx.botName
  );

/**
 * Solutions whose failed auto-publish the person has already been told about
 * (PSTUDIO-4589). The version reload that follows a refused first publish
 * would otherwise add "Last version v1 was deployed with errors. Check your
 * CSV file…" on top. One-shot: the next load takes it, and later loads behave
 * as on candidate. Only auto-publish (a Bobcat flag) marks it, so with the
 * flags off nothing changes.
 */
const announcedFailures = new Set<string>();

export const markAutoPublishFailureAnnounced = (key: string): void => {
  announcedFailures.add(key);
};

/** Whether a failure was announced for this solution; clears it either way. */
export const takeAutoPublishFailureAnnounced = (key: string): boolean =>
  announcedFailures.delete(key);
